var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconQes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 26.3142V12.3142L14.6413 16.4229L12.8846 14.6154L20 7.5L27.1154 14.6154L25.3587 16.4229L21.25 12.3142V26.3142H18.75ZM10.5129 32.5C9.67097 32.5 8.95833 32.2083 8.375 31.625C7.79167 31.0417 7.5 30.329 7.5 29.4871V24.9679H10V29.4871C10 29.6154 10.0535 29.7329 10.1604 29.8396C10.2671 29.9465 10.3846 30 10.5129 30H29.4871C29.6154 30 29.7329 29.9465 29.8396 29.8396C29.9465 29.7329 30 29.6154 30 29.4871V24.9679H32.5V29.4871C32.5 30.329 32.2083 31.0417 31.625 31.625C31.0417 32.2083 30.329 32.5 29.4871 32.5H10.5129Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconQes);
export default __webpack_public_path__ + "static/media/UploadIconQES.de09aad7745adab09d8562ad664a1170.svg";
export { ForwardRef as ReactComponent };